export default __webpack_public_path__ + "static/media/study-support.7eb97cf4.svg";